import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "ta-c" };
const _hoisted_2 = { class: "ta-c" };
const _hoisted_3 = { class: "ta-c" };
const _hoisted_4 = { class: "ta-c" };
const _hoisted_5 = { class: "ta-c" };
const _hoisted_6 = { class: "ta-c" };
const _hoisted_7 = ["title"];
import { formatDate, isTodayTextColor, } from '@/utils';
import dateFormatType from '@/constants/dateFormatType';
import { enumOperationType } from '@/constants/requestMap';
import { computed } from 'vue';
import { autoLc } from '@/locales/ko/views/request_map';
import { pStore } from '@/pinia';
import vuexStore from '@/vuex-store';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { alertActionType } from '@/vuex-store/alert/actions';
import { isToday } from 'date-fns';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Item',
    props: {
        item: {}
    },
    setup(__props) {
        const lc = autoLc();
        const piniaStore = pStore.piniaRequestMap;
        const props = __props;
        const typeClass = computed(() => {
            const cssClass = {};
            if (props.item.operationType === 'CREATE') {
                cssClass['brg-color-blue-700'] = true;
            }
            if (props.item.operationType === 'UPDATE') {
                cssClass['brg-color-orange-800'] = true;
            }
            return cssClass;
        });
        /**
         * 취소 버튼 클릭 핸들러
         */
        const handleClickRequestCancelBtn = async () => {
            // 팝업
            const isConfirmOk = await vuexStore.dispatch(alertActionType.confirm, {
                headerTitle: lc('list.cancel_request'),
                bodyContent: lc('list.cancel_request_body'),
            });
            if (!isConfirmOk) {
                return;
            }
            try {
                await piniaStore.cancelItem(props.item.id);
                vuexStore.dispatch(snackbarActionType.showSuccess);
                piniaStore.getItemList();
            }
            catch (error) {
                console.log('[handleClickRequestCancelBtn]', error);
                vuexStore.dispatch(snackbarActionType.showError);
            }
            // api get
        };
        return (_ctx, _cache) => {
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_btn = _resolveComponent("v-btn");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("tr", null, [
                _createCommentVNode(" 아이디 "),
                _createElementVNode("td", _hoisted_1, _toDisplayString(props.item.id), 1 /* TEXT */),
                _createCommentVNode(" 요청 구분"),
                _createElementVNode("td", _hoisted_2, [
                    _createVNode(_component_v_chip, {
                        class: _normalizeClass(typeClass.value)
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(enumOperationType)[props.item.operationType]), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["class"])
                ]),
                _createCommentVNode(" 제목 (풀주소) "),
                _createElementVNode("td", _hoisted_3, _toDisplayString(props.item.address?.getFullAddress('LOT_NUMBER')), 1 /* TEXT */),
                _createCommentVNode(" 결과 "),
                _createElementVNode("td", _hoisted_4, [
                    (props.item.resultType === 'REQUEST')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createCommentVNode(" 요청취소 "),
                            _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: handleClickRequestCancelBtn }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(lc)('list.cancel_request')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })), [
                                [
                                    _directive_btn_style,
                                    void 0,
                                    "config",
                                    {
                                        "size-xs": true,
                                        info: true,
                                        outlined: true
                                    }
                                ]
                            ])
                        ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true),
                    (props.item.resultType === 'COMPLETED')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_unref(lc)('list.completed')), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true),
                    (props.item.resultType === 'ALREADY')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(_unref(lc)('list.already')), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" 요청자 "),
                _createElementVNode("td", _hoisted_5, _toDisplayString(props.item.createdBy), 1 /* TEXT */),
                _createCommentVNode(" 등록일 "),
                _createElementVNode("td", _hoisted_6, [
                    _createElementVNode("span", {
                        title: _unref(isToday)(props.item.createdAt) ? '빨강색은 오늘 등록된 글입니다.' : '',
                        class: _normalizeClass(_unref(isTodayTextColor)(props.item.createdAt))
                    }, _toDisplayString(_unref(formatDate)(props.item.createdAt, _unref(dateFormatType).FULL_DATE_MINUTE)), 11 /* TEXT, CLASS, PROPS */, _hoisted_7)
                ])
            ]));
        };
    }
});
